import React from 'react';

// Downloadable docs live in public/docs/. Drop the files there and rename
// if needed; these hrefs resolve relative to the site root at runtime.
const DOCS = [
  { href: '/docs/GRX-Whitepaper.pdf', label: 'Whitepaper',  icon: '📄' },
  { href: '/docs/GRX-PitchDeck.pdf',  label: 'Pitch Deck',  icon: '📊' },
];

const Footer = () => (
  <footer className="app-footer">
    <div className="footer-docs">
      {DOCS.map((d) => (
        <a
          key={d.href}
          className="footer-doc-btn"
          href={d.href}
          target="_blank"
          rel="noreferrer"
          download
        >
          <span className="fdb-icon">{d.icon}</span>
          <span className="fdb-label">Download {d.label}</span>
          <span className="fdb-ext">PDF</span>
        </a>
      ))}
    </div>
    <div>◆ GRAPHENEX ECOSYSTEM · GRX Token · {new Date().getFullYear()} ◆</div>
    <div style={{ marginTop: 6, opacity: 0.6 }}>Powered by Smart Contracts</div>
  </footer>
);

export default Footer;
